import React from "react"

import SignIn from "pages/signIn"

const publicRoutes = [
  {
    path: "/",
    component: <SignIn />
  }
]

export default publicRoutes